import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../components/LoadingSpinner';
import {
  CanAccessPartnerData,
  ViewerContext,
} from '../../providers/ViewerContextProvider';
import ScrollToTop from '@/utils/scrollToTop';
import i18n, { getDateFormatOptions } from '@/utils/i18n';
import { usePartnerSelfSignupQuery } from '../../graphql/queries/partnerSelfSignUp.generated';

function SelfSignupAddress({ address }) {
  return (
    <>
      <dt className="col-sm-3">street</dt>
      <dd className="col-sm-9">{address.street}</dd>

      <dt className="col-sm-3">zipcode</dt>
      <dd className="col-sm-9">{address.zipcode}</dd>

      <dt className="col-sm-3">city</dt>
      <dd className="col-sm-9">{address.city}</dd>

      <dt className="col-sm-3">country</dt>
      <dd className="col-sm-9">{address.country}</dd>
    </>
  );
}

export default function AdminPartnerSelfSignup({
  match: {
    params: { partnerSelfSignupId },
  },
}) {
  const { data = { partnerSelfSignup: null }, loading } =
    usePartnerSelfSignupQuery({
      variables: { id: partnerSelfSignupId },
      fetchPolicy: 'network-only',
    });

  const viewer = useContext(ViewerContext);
  const allowedToAccess = CanAccessPartnerData(viewer);

  console.log(data);
  const partnerSelfSignup = data.partnerSelfSignup;

  if (!allowedToAccess) {
    return null;
  }

  return (
    <div className="p-3">
      <ScrollToTop />

      {loading && <Spinner />}

      <br />
      <h2>
        Partner Self Signup{' '}
        <code>{partnerSelfSignup && partnerSelfSignup.id}</code>
      </h2>
      {partnerSelfSignup && (
        <>
          {/*
          <SelfSignupSteps>
            {signupSteps.map((signupStep, i) => (<SelfSignupStep completed={signupStep.completed}>
              <SelfSignupStepNumber>{ i + 1 }</SelfSignupStepNumber>
              <SelfSignupStepName>{signupStep.name}</SelfSignupStepName>
            </SelfSignupStep>))}
          </SelfSignupSteps>
          */}
          <br />
          <br />

          <dt className="col-sm-3">created at</dt>
          <dd className="col-sm-9">
            {new Date(partnerSelfSignup.created_at).toLocaleDateString(
              i18n.language,
              getDateFormatOptions(true),
            )}
          </dd>

          <dt className="col-sm-3">Panda Doc Contract</dt>
          <dd className="col-sm-9">
            {partnerSelfSignup.panda_doc_id ? (
              <a
                href={
                  'https://app.pandadoc.com/a/#/documents/' +
                  partnerSelfSignup.panda_doc_id
                }
              >
                Contract
              </a>
            ) : (
              'not created yet'
            )}
          </dd>

          <dt className="col-sm-3">signed at</dt>
          <dd className="col-sm-9">
            {partnerSelfSignup.signed_at
              ? new Date(partnerSelfSignup.signed_at).toLocaleDateString(
                  i18n.language,
                  getDateFormatOptions(true),
                )
              : 'not signed yet'}
          </dd>

          <dt className="col-sm-3">company name</dt>
          <dd className="col-sm-9">{partnerSelfSignup.company_name}</dd>

          <dt className="col-sm-3">company type</dt>
          <dd className="col-sm-9">{partnerSelfSignup.company_type}</dd>

          <dt className="col-sm-3">email</dt>
          <dd className="col-sm-9">{partnerSelfSignup.email}</dd>

          <dt className="col-sm-3">phone</dt>
          <dd className="col-sm-9">{partnerSelfSignup.phone}</dd>

          <dt className="col-sm-3">package</dt>
          <dd className="col-sm-9">{partnerSelfSignup.package}</dd>

          <br />
          <br />

          <dt className="col-sm-3">first name</dt>
          <dd className="col-sm-9">{partnerSelfSignup.first_name}</dd>

          <dt className="col-sm-3">last name</dt>
          <dd className="col-sm-9">{partnerSelfSignup.last_name}</dd>

          <dt className="col-sm-3">How did you know about Vytal</dt>
          <dd className="col-sm-9">
            {partnerSelfSignup.how_did_you_know_about_vytal}
          </dd>

          <br />
          <br />

          <dt className="col-sm-3">Iban name</dt>
          <dd className="col-sm-9">{partnerSelfSignup.iban_name}</dd>

          <dt className="col-sm-3">iban</dt>
          <dd className="col-sm-9">{partnerSelfSignup.iban}</dd>

          <dt className="col-sm-3">VAT</dt>
          <dd className="col-sm-9">{partnerSelfSignup.vat}</dd>

          <dt className="col-sm-3">BIC</dt>
          <dd className="col-sm-9">{partnerSelfSignup.bic}</dd>

          <br />
          <br />

          {partnerSelfSignup.address && (
            <>
              <h4 className="col-12">address</h4>
              <SelfSignupAddress address={partnerSelfSignup.address} />
              <br />
            </>
          )}

          {partnerSelfSignup.billing_address && (
            <>
              <h4 className="col-12">billing address</h4>
              <SelfSignupAddress address={partnerSelfSignup.billing_address} />
              <br />
            </>
          )}
        </>
      )}
      <br />
    </div>
  );
}

AdminPartnerSelfSignup.propTypes = {
  match: PropTypes.object.isRequired,
};
